import React, { useEffect } from "react";
import cl from "./Cokie.module.css";
import { animateScroll as scroll } from "react-scroll";

const Cokie = (props) => {
  useEffect(() => {
    scroll.scrollToTop();
  }, []);

  return (
    <section className={cl.app_policy}>
      <h1>Política de Cookies para {props.shopName}</h1>
      <p>Última actualización: 07 de febrero de 2024</p>

      <h4>Tecnologías de Rastreo y Cookies</h4>
      <p>
        Utilizamos Cookies y tecnologías de rastreo similares para monitorear la
        actividad en Nuestro Servicio y almacenar cierta información. Las
        tecnologías de rastreo utilizadas pueden incluir balizas, etiquetas y
        scripts para recopilar y rastrear información y para mejorar y analizar
        Nuestro Servicio. Las tecnologías que utilizamos pueden incluir:
      </p>
      <ul style={{ marginLeft: "30px" }}>
        <li style={{ marginBottom: "10px" }}>
          <strong>Cookies o Cookies del Navegador.</strong> Una cookie es un
          pequeño archivo colocado en Tu Dispositivo. Puedes instruir a Tu
          navegador para que rechace todas las Cookies o para que indique cuándo
          se envía una Cookie. Sin embargo, si no aceptas las Cookies, es
          posible que no puedas usar algunas partes de nuestro Servicio. A menos
          que hayas ajustado la configuración de Tu navegador para que rechace
          las Cookies, nuestro Servicio puede utilizar Cookies.
        </li>
        <li>
          <strong>Web Beacons.</strong> Algunas secciones de nuestro Servicio y
          de nuestros correos electrónicos pueden contener pequeños archivos
          electrónicos conocidos como web beacons (también llamados gifs
          transparentes, etiquetas de píxeles y gifs de píxeles únicos) que
          permiten a la Compañía, por ejemplo, contar a los usuarios que han
          visitado esas páginas o abierto un correo electrónico y para otras
          estadísticas relacionadas con el sitio web (por ejemplo, registrar la
          popularidad de una sección en particular y verificar la integridad del
          sistema y del servidor).
        </li>
      </ul>
      <p>
        Las Cookies pueden ser "Persistentes" o "de Sesión". Las Cookies
        Persistentes permanecen en Tu computadora personal o dispositivo móvil
        cuando estás fuera de línea, mientras que las Cookies de Sesión se
        eliminan tan pronto como cierras Tu navegador web. Puedes obtener más
        información sobre las cookies en el artículo de {props.shopName}.
      </p>
      <p>
        Utilizamos tanto Cookies de Sesión como Persistentes para los siguientes
        fines:
      </p>
      <ul style={{ marginLeft: "30px" }}>
        <li>
          <p>
            <strong>Cookies Necesarias / Esenciales</strong>
          </p>
          <p>Tipo: Cookie de Sesión</p>
          <p>Administradas por: Nosotros</p>
          <p>
            Propósito: Estas Cookies son esenciales para proporcionarte los
            servicios disponibles a través del Sitio Web y para permitirte
            utilizar algunas de sus funciones. Ayudan a autenticar a los
            usuarios y a prevenir el uso fraudulento de las cuentas de usuario.
            Sin estas Cookies, los servicios que has solicitado no pueden ser
            proporcionados y solo utilizamos estas Cookies para proporcionarte
            esos servicios.
          </p>
        </li>

        {/* ьльль */}
        <li>
          <p>
            <strong>
              Política de Cookies / Cookies de Aceptación de Aviso
            </strong>
          </p>
          <p>Tipo: Cookies Persistentes</p>
          <p>Administradas por: Nosotros</p>
          <p>
            Propósito: Estas cookies identifican si los usuarios han aceptado el
            uso de cookies en el Sitio Web.
          </p>
        </li>
        <li>
          <p>
            <strong>Cookies de Funcionalidad</strong>
          </p>
          <p>Tipo: Cookies Persistentes</p>
          <p>Administradas por: Nosotros</p>
          <p>
            Propósito: Estas cookies nos permiten recordar las elecciones que
            haces cuando utilizas el Sitio Web, como por ejemplo recordar tus
            detalles de acceso o tus preferencias de idioma. El propósito de
            estas cookies es proporcionarte una experiencia más personal y
            evitar que tengas que volver a ingresar tus preferencias cada vez
            que uses el Sitio Web.
          </p>
        </li>
      </ul>
      <p>
        Para obtener más información sobre las cookies que utilizamos y tus
        opciones con respecto a las cookies, visita nuestra Política de Cookies
        o la sección de Cookies de nuestra Política de Privacidad.
      </p>
      <p>
        Sin embargo, si aún buscas más información, puedes contactarnos a través
        de uno de nuestros métodos de contacto preferidos:
      </p>

      <ul style={{ marginLeft: "30px" }}>
        <li>Email: supporto@{props.domain}</li>
      </ul>
    </section>
  );
};

export default Cokie;
